// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2SA4N","empty":"ModalGraph_empty__R64eD"};